<template>
  <div>
    <van-sticky>
      <van-nav-bar title="折上折金币提现说明" left-arrow @click-left="goBack" />
    </van-sticky>
    <div class="page">
      <h3>金币换算规则</h3>
      <p>
        根据国家规定，在《个人所得税法》第三条第五项明文规定，偶然所得将扣除百分之二十税费
      </p>
      <div class="formula">（金币数目*0.8）/100=提现金额</div>
    </div>
    <div class="page">
      <h3>提现方式</h3>
      <p>
        提现时，仅支持绑定的微信账户提现。
        转入的金额请以微信客支付消息提示为准。
        温馨提示：可提现的资金需要与平台计算的资金为准。
      </p>
    </div>
    <div class="page">
      <h3>普通提现</h3>
      <p>提现无限额，100以上T+1日转出到微信账户</p>
      <!-- <div class="img">
        <img src="@/assets/images/gold-coin/gold_time.png" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  border-bottom: 5px solid #eee;
  padding: 10px;
  h3 {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 11px;
    color: #323233;
  }
  p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #323233;
  }
}
.formula {
  text-align: center;
  color: #985d1f;
  margin-bottom: 5px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 11px;
}
.img {
  padding-bottom: 10px;
  // border-bottom: 5px solid #eeeeee;
  text-align: center;
  img {
    width: 300px;
  }
}
</style>